import React, { useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, Menu, MenuItem } from '@mui/material';

import { ReadFile, useHiddenFileSelect } from '@paragon/client-tools';
import { isLoggedInUserRoot } from '@paragon/login-tools';
import { enqueueError } from '@paragon/notification-tools';

import { exportProject } from '../../store/actions/download';
import { importPpf } from '../../store/actions/projects';
import { useAppDispatch, useAppSelector } from '../hooks';

export function ProjectRootActionsMenu({ projectGuid }: { readonly projectGuid: string }) {
  const dispatch = useAppDispatch();
  const isRootUser = useAppSelector(isLoggedInUserRoot);

  const [renderFileSelect, selectPpfFile] = useHiddenFileSelect('.ppf', false);
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);
  const closeMenu = () => setMenuAnchorEl(null);
  const runAndCloseMenu = (action: () => void) => () => {
    closeMenu();
    action();
  };

  const onImport = (file: ReadFile) => {
    if (file.filetype !== 'ppf') {
      dispatch(enqueueError('You must supply a PPF file.'));
      return;
    }
    dispatch(importPpf(projectGuid, file));
  };

  if (!isRootUser) return null;

  return (
    <>
      <IconButton
        size="small"
        aria-label="More project actions"
        onClick={(event) => setMenuAnchorEl(event.currentTarget)}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={menuAnchorEl} open={menuAnchorEl != null} onClose={closeMenu}>
        <MenuItem onClick={runAndCloseMenu(() => dispatch(exportProject(projectGuid)))}>Export PPF</MenuItem>
        <MenuItem onClick={runAndCloseMenu(() => void selectPpfFile().then(onImport))}>Import PPF</MenuItem>
      </Menu>
      {renderFileSelect()}
    </>
  );
}
